export default __webpack_public_path__ + "images/arrow-right_cb4b0b.svg";